import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

function Stat({ label, value, testId }) {
  return (
    <div className="border border-ink/15 p-6 bg-white" data-testid={testId}>
      <p className="label-mono opacity-60">{label}</p>
      <p className="mt-3 font-editorial text-5xl">{value ?? "—"}</p>
    </div>
  );
}

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <p className="label-mono opacity-60">Overview</p>
      <h1 className="mt-2 font-editorial text-5xl md:text-6xl">Dashboard</h1>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
        <Stat label="New enquiries" value={stats?.new_enquiries} testId="stat-new-enquiries" />
        <Stat label="Total enquiries" value={stats?.total_enquiries} testId="stat-total-enquiries" />
        <Stat label="Confirmed bookings" value={stats?.confirmed_bookings} testId="stat-confirmed" />
        <Stat label="Upcoming shoots" value={stats?.upcoming_shoots} testId="stat-upcoming" />
        <Stat label="Published projects" value={stats?.published_projects} testId="stat-published" />
        <Stat label="Draft projects" value={stats?.draft_projects} testId="stat-draft" />
      </div>

      <div className="mt-14">
        <h2 className="font-editorial text-3xl mb-4">Most requested service</h2>
        <p className="label-mono opacity-70">{stats?.most_requested_service || "No enquiries yet"}</p>
      </div>

      <div className="mt-14">
        <h2 className="font-editorial text-3xl mb-6">Recent activity</h2>
        <div className="border border-ink/15 divide-y divide-ink/10 bg-white">
          {(stats?.recent_activity || []).length === 0 && (
            <p className="p-6 label-mono opacity-60">No enquiries yet.</p>
          )}
          {(stats?.recent_activity || []).map((e) => (
            <div key={e.id} className="p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
              <div>
                <p className="font-editorial text-lg">{e.full_name} · <span className="italic">{e.service_category}</span></p>
                <p className="label-mono opacity-60">{e.reference} · {e.status}</p>
              </div>
              <Link to={`/admin/enquiries?ref=${e.reference}`} className="hover-underline label-mono">
                View →
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
